import {
  SEARCHING_ASSETS_REQUEST, SEARCHING_ASSETS_SUCCEEDED, SEARCHING_ASSETS_FAILED,
  INVALIDATE_ASSETS_SEARCH, GENERATE_ASSET_LINK_REQUEST, GENERATE_ASSET_LINK_SUCCEDDED,
  GENERATE_ASSET_LINK_FAILED, INVALIDATE_ASSET_LINK, GENERATE_ASSET_LINK_BULK_REQUEST,
  GENERATE_ASSET_LINK_BULK_REQUEST_SUCCEDDED, GENERATE_ASSET_LINK_BULK_REQUEST_FAILED,
  UPDATE_ASSETS_LINK_REQUEST, UPDATE_ASSETS_LINK_REQUEST_SUCCEDDED, UPDATE_ASSETS_LINK_REQUEST_FAILED,
  FETCHING_SHARED_ASSETS_REQUEST, FETCHING_SHARED_ASSETS_SUCCEDDED, FETCHING_SHARED_ASSETS_FAILED,
  FETCHING_FREQUENTLY_SHARED_ASSETS_REQUEST, FETCHING_FREQUENTLY_SHARED_ASSETS_SUCCEDDED, FETCHING_FREQUENTLY_SHARED_ASSETS_FAILED,
   FETCHING_RECOMMENDED_ASSETS_REQUEST, FETCHING_RECOMMENDED_ASSETS_SUCCEEDED, FETCHING_RECOMMENDED_ASSETS_FAILED, 
   INVALIDATE_RECOMMENDED_ASSETS, FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_REQUEST, FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_SUCCEEDED, FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_FAILED
} from 'constants/actionTypes';

import { createAction } from 'redux-actions';
import axios from 'axios';
import buildUrl from 'build-url';
import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';

const apiUrl = process.env.REACT_APP_API_URL;
const SEARCH_BASE_URL = `${apiUrl}/api/2.0/search`;
const ASSETS_BASE_URL = `${apiUrl}/api/2.0/assets`;
const HUB_BASE_URL = `${apiUrl}/api/2.1/hub`;
const INTEGRATIONS_BASE_URL = `${apiUrl}/api/2.1/integrations`;

/*
* Search assets
*/
export const searchAssets = createAction(SEARCHING_ASSETS_REQUEST, (query, page, limit) => {
  return { query, page, limit };
});
const searchingAssetsSucceeded = createAction(SEARCHING_ASSETS_SUCCEEDED, (query, response) => ({ query, response }));
const searchingAssetsFailed = createAction(SEARCHING_ASSETS_FAILED, (query, error) => ({ query, error }));

export const invalidateAssetsSearch = createAction(INVALIDATE_ASSETS_SEARCH);

function* searchAssetsSaga(action) {
  const { query, page, limit } = action.payload;

  let url = buildUrl(SEARCH_BASE_URL, {
    path: `assets/${page}`
  });

  let param = {
    query: query,
    limit: limit
  }

  const searchAssetsAPI = () => {
    return axios({
      method: 'GET',
      url: url,
      params: param,
    }).then(response => response.data);
  }

  try {
    const response = yield call(searchAssetsAPI);
    yield put(searchingAssetsSucceeded(query, response));
  } catch (error) {
    yield put(searchingAssetsFailed(query, error));
  }
}


/**
*  Generate Asset Anonymous link
*/
export const generateAssetLink = createAction(GENERATE_ASSET_LINK_REQUEST, (asset, request, callback) => {
  return { asset, request, callback };
});
const generatingAssetLinkSuccedded = createAction(GENERATE_ASSET_LINK_SUCCEDDED);
const generatingAssetLinkFailed = createAction(GENERATE_ASSET_LINK_FAILED);

function* generateAssetLinkSaga(action) {
  const { asset, request, callback } = action.payload;
  const assetId = asset.id;

  let url = buildUrl(ASSETS_BASE_URL, {
    path: `${assetId}/link`
  });

  const createGenerateAssetLinkAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: request
    }).then(response => response.data);
  }

  try {
    const response = yield call(createGenerateAssetLinkAPI);
    yield put(generatingAssetLinkSuccedded({ assetId, response }));
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(generatingAssetLinkFailed({ assetId, error }));
  }
}

/** 
* Generate Asset link bulk request
*/
export const generateAssetLinkBulkRequest = createAction(GENERATE_ASSET_LINK_BULK_REQUEST, (assets, request, callback) => {
  return { assets, request, callback }
});

const generateAssetLinkBulkRequestSuccedded = createAction(GENERATE_ASSET_LINK_BULK_REQUEST_SUCCEDDED);
const generateAssetLinkBulkRequestFailed = createAction(GENERATE_ASSET_LINK_BULK_REQUEST_FAILED);

function* generateAssetLinkBulkRequestSaga(action) {
  const { assets, request, callback } = action.payload;

  const createGenerateAssetLinkAPI = (asset) => {

    let url = buildUrl(ASSETS_BASE_URL, {
      path: `/link`
    });

    return axios({
      method: 'POST',
      url: url,
      data: request
    }).then(response => {
      return {
        [asset.id]: response.data
      }
    });
  }

  try {
    const responses = yield all(assets.map(asset => call(createGenerateAssetLinkAPI, asset)));
    yield put(generateAssetLinkBulkRequestSuccedded({ assets, responses }));
    if (callback) {
      callback(responses);
    }
  } catch (error) {
    yield put(generateAssetLinkBulkRequestFailed({ assets, error }));
  }
}

/** 
* Update Assets link bulk request
*/
export const updateAssetsLink = createAction(UPDATE_ASSETS_LINK_REQUEST, (integrationSharedUrlId, request, callback) => {
  return { integrationSharedUrlId, request, callback }
});

const updateAssetsLinkRequestSuccedded = createAction(UPDATE_ASSETS_LINK_REQUEST_SUCCEDDED);
const updateAssetsLinkRequestFailed = createAction(UPDATE_ASSETS_LINK_REQUEST_FAILED);

function* updateAssetsLinkRequestSaga(action) {
  const { integrationSharedUrlId, request, callback } = action.payload;

  const updateAssetsLinkAPI = (id, request) => {

    let url = buildUrl(ASSETS_BASE_URL, {
      path: `${id}/link`
    });

    return axios({
      method: 'PUT',
      url: url,
      data: request
    }).then(response => {
      return response.data;
    });
  }

  try {
    const responses = yield call(updateAssetsLinkAPI, integrationSharedUrlId, request);
    yield put(updateAssetsLinkRequestSuccedded({ request, responses }));
    if (callback) {
      callback(responses);
    }
  } catch (error) {
    yield put(updateAssetsLinkRequestFailed({ request, error }));
  }
}

/* Fetch Selected Assets */

export const fetchSharedAssets = createAction(FETCHING_SHARED_ASSETS_REQUEST, (integrationSharedUrlId, callback) => {
  return { integrationSharedUrlId, callback }
});

const fetchingSharedAssetsSucceeded = createAction(FETCHING_SHARED_ASSETS_SUCCEDDED);
const fetchingSharedAssetsFailed = createAction(FETCHING_SHARED_ASSETS_FAILED);

function* fetchingSharedAssetsSaga(action) {

  const { integrationSharedUrlId, callback } = action.payload;

  
  const fetchSharedAssetsAPI = (id) => {
    let url = buildUrl(ASSETS_BASE_URL, {
      path: `${id}/assets`
    });

    return axios({
      method: 'GET',
      url: url
    }).then(response => {
      return response.data;
    });;
  }

  try {
    const response = yield call(fetchSharedAssetsAPI, integrationSharedUrlId);
    yield put(fetchingSharedAssetsSucceeded(response));
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(fetchingSharedAssetsFailed(error));
  }
}

/*
* Search assets
*/
export const fetchFrequentlySharedAssets = createAction(FETCHING_FREQUENTLY_SHARED_ASSETS_REQUEST, () => {
  return;
});
const fetchingFrequentlySharedAssetsSucceeded = createAction(FETCHING_FREQUENTLY_SHARED_ASSETS_SUCCEDDED, (response) => ({ response }));
const fetchingFrequentlySharedAssetsFailed = createAction(FETCHING_FREQUENTLY_SHARED_ASSETS_FAILED, (error) => ({ error }));

function* fetchingFrequentlySharedAssetsSaga(action) {

  let url = buildUrl(ASSETS_BASE_URL, {
    path: `frequently-shared-assets`
  });

  const searchAssetsAPI = () => {
    return axios({
      method: 'GET',
      url: url
    }).then(response => response.data);
  }

  try {
    const response = yield call(searchAssetsAPI);
    yield put(fetchingFrequentlySharedAssetsSucceeded(response));
  } catch (error) {
    yield put(fetchingFrequentlySharedAssetsFailed(error));
  }
}

export const fetchRecommendedAssets = createAction(FETCHING_RECOMMENDED_ASSETS_REQUEST, (request) => {
  return {request};
})
const fetchingRecommendedAssetsSucceeded = createAction(FETCHING_RECOMMENDED_ASSETS_SUCCEEDED, (response) => ({response}));
const fetchingRecommendedAssetsFailed = createAction(FETCHING_RECOMMENDED_ASSETS_FAILED, (error) => ({error}));

function* fetchingRecommendedAssetsSaga(action){
  const { request } = action.payload;

  let url = buildUrl(ASSETS_BASE_URL, {
    path: `recommended_assets`
  });

  const searchAssetsAPI = (request) => {
    return axios({
      method: 'POST',
      url: url,
      data: request
    }).then(response => response.data);
  }

  try{
    const response = yield call(searchAssetsAPI, request);
    yield put(fetchingRecommendedAssetsSucceeded(response));
  }catch (error) {
    yield put(fetchingRecommendedAssetsFailed(error));
  }
}

export const fetchRecommendedAssetsForDeal = createAction(FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_REQUEST, (id, integrationType) => {
  return {id, integrationType};
})
const fetchingRecommendedAssetsForDealSucceeded = createAction(FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_SUCCEEDED, (response) => ({response}));
const fetchingRecommendedAssetsForDealFailed = createAction(FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_FAILED, (error) => ({error}));

function* fetchingRecommendedAssetsForDealSaga(action){
  const { id, integrationType } = action.payload;

  let url = null;

  //  have to use a combined API later
  if(integrationType === "hubspot"){
    url = buildUrl(apiUrl, {
      path: `api/2.0/integrations/${integrationType}/recommended-assets/${id}`
    });
  } else if(integrationType === "ms_dynamics_v2"){
    url = buildUrl(INTEGRATIONS_BASE_URL, {
      path: `ms-dynamics/opportunities/${id}/recommended-assets`
    });
  }
  else {
    url = buildUrl(apiUrl, {
      path: `api/2.0/crm/opportunities/${id}/recommended-assets`
    });
  }

  const fetchRecommendedAssetsForDealApi = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then(response => response.data);
  }

  try{
    const response = yield call(fetchRecommendedAssetsForDealApi);
    yield put(fetchingRecommendedAssetsForDealSucceeded(response));
  }catch (error) {
    yield put(fetchingRecommendedAssetsForDealFailed(error));
  }
}

export const invalidateRecommendedAssets = createAction(INVALIDATE_RECOMMENDED_ASSETS);

export default function* assetsSaga() {
  yield takeEvery(SEARCHING_ASSETS_REQUEST, searchAssetsSaga);
  yield takeEvery(GENERATE_ASSET_LINK_REQUEST, generateAssetLinkSaga);
  yield takeEvery(GENERATE_ASSET_LINK_BULK_REQUEST, generateAssetLinkBulkRequestSaga);
  yield takeEvery(UPDATE_ASSETS_LINK_REQUEST, updateAssetsLinkRequestSaga);
  yield takeEvery(FETCHING_SHARED_ASSETS_REQUEST, fetchingSharedAssetsSaga);
  yield takeEvery(FETCHING_FREQUENTLY_SHARED_ASSETS_REQUEST, fetchingFrequentlySharedAssetsSaga);
  yield takeEvery(FETCHING_RECOMMENDED_ASSETS_REQUEST, fetchingRecommendedAssetsSaga);
  yield takeEvery(FETCHING_RECOMMENDED_ASSETS_FOR_DEAL_REQUEST, fetchingRecommendedAssetsForDealSaga);
};
